import { useCappsPropertyDetailsWebApiHandler_details } from '@zg-rentals/ts-capps-client-react-query';
import { API, BASE_URL } from '../../constants/urls';
import { useMutation, useQueryClient } from '@zg-rentals/react-query5';

export type ApplicationsAcceptedRequest = {
  applicationsAccepted: boolean;
  listingAlias: string;
};

export type ApplicationsAcceptedResponse = {
  success: boolean;
};

export const SET_APPLICATIONS_ACCEPTED_QUERY_KEY = 'setApplicationsAccepted';

async function setApplicationsAccepted(body: ApplicationsAcceptedRequest): Promise<ApplicationsAcceptedResponse> {
  const { listingAlias, applicationsAccepted } = body;
  const response = await fetch(
    `${BASE_URL}${API.SET_APPLICATIONS_ACCEPTED}?propertyId=${listingAlias}&applicationsAccepted=${applicationsAccepted}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    },
  );
  if (!response.ok) {
    return Promise.reject('Failed to set applications');
  }
  return await response.json();
}

export function useSetApplicationsAccepted(listingAlias: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [SET_APPLICATIONS_ACCEPTED_QUERY_KEY, listingAlias],
    mutationFn: (applicationsAccepted: boolean) =>
      setApplicationsAccepted({
        applicationsAccepted,
        listingAlias,
      }),
    onSuccess: (_, applicationsAccepted) => {
      queryClient.setQueryData(useCappsPropertyDetailsWebApiHandler_details.getKey({ listingAlias }), (oldData) =>
        oldData ? { ...oldData, applicationsAccepted } : oldData,
      );
    },
  });
}
